module.exports = __webpack_public_path__ + "img/资源库首图.9870bf92.png";